import { useState } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { KeenIcon } from '@/components';

const AuthEmail = ({ data, onConfirm, loadData, loadDataSave }) => {
  const [emailInput, setEmailInput] = useState(data?.firm_email);
  const [isEditing, setIsEditing] = useState(false);

  const handleCancel = (resetForm) => {
    setIsEditing(false)
    resetForm()
  }

  const formFields = {
    firm_email: { label: 'Firm Email' },
  };
  
  const validationSchema = Yup.object().shape({
    firm_email: Yup.string().required('Firm email is required'),
  });

  const initialValues = {
    account_owner: data?.account_owner || '',
    legal_business_name: data?.legal_business_name || '',
    country: data?.country || '',
    address: data?.address || '',
    address_2: data?.address_2 || '',
    city: data?.city || '',
    zip_postal_code: data?.zip_postal_code || '',
    phone_number: data?.phone_number || '',
    firm_email: data?.firm_email || '',
    website: data?.website || '',
    tax_id: data?.tax_id || '',
    date_format: data?.date_format || '',
    time_format: data?.time_format || '',
    // company_logo: data?.company_logo ? [{ dataURL: data?.company_logo }] : []
    company_logo: data?.company_logo ? data?.company_logo : []
  }

  return <div className="card pb-2.5">
      <div className="card-header" id="auth_email">
        <h3 className="card-title">Firm Email</h3>
        <button onClick={() => setIsEditing(true)} className="btn btn-xs btn-icon btn-icon-lg link">
          <KeenIcon icon="notepad-edit" className="text-[12px]" />
        </button>
      </div>

      <div className="card-body grid gap-5 pt-7.5">
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          enableReinitialize
          onSubmit={(values) => {
            const formData = new FormData();
              const avatarFile = Array.isArray(values.company_logo) && values.company_logo.length > 0
              ? values.company_logo[0].file
              : values.company_logo;
              const finalData = {
                ...initialValues,   
                ...values,      
              };
              console.log('finalData', finalData)
              Object.entries(finalData).forEach(([key, value]) => {
                formData.append(key, value ?? '');
              });
              
              formData.append('_method', 'PUT');
              for (let pair of formData.entries()) {
                console.log(pair[0] + ': ' + pair[1]);
              }
            // return
            onConfirm(formData);
            setIsEditing(false);
          }}
        >
          {({ errors, values, setFieldValue, resetForm }) => (
            <Form>
              <table className="table align-middle text-sm text-gray-500">
                <tbody>
                  {loadData || loadDataSave ? (
                    <tr>
                      <td colSpan={2} className="text-center py-4">
                        <span>Loading...</span>
                      </td>
                    </tr>
                  ) : (
                    <>
                      {/* <tr>
                        <td className="text-gray-800 font-medium">Firm Info</td>
                        <td></td>
                      </tr> */}

                      {Object.entries(formFields).map(([key, config]) => (
                        <tr key={key}>
                          <td className="py-2 text-gray-600">{config.label}</td>
                          <td className="py-2 text-gray-800">
                            {isEditing ? (
                              <>
                                <Field name={key} className="input input-sm input-bordered w-full" />
                                <ErrorMessage name={key} component="div" className="text-red-500 text-xs mt-1" />
                              </>
                            ) : (
                              key === 'firm_email'
                              ? <a href={`mailto:${values[key]}`} rel="noopener noreferrer" className="link">
                                  {values[key]}
                                </a>
                              : values[key] || '—'
                            )}
                          </td>
                        </tr>
                      ))}
                      {isEditing && (
                        <tr>
                          <td></td>
                          <td className="pt-3">
                            <button
                              type="submit"
                              disabled={loadDataSave}
                              className="btn btn-sm btn-primary"
                            >
                              {loadDataSave ? "Saving..." : "Save"}
                            </button>
                            <button
                              type="button"
                              onClick={() => {handleCancel(resetForm)}}
                              className="btn btn-sm "
                            >
                              Cancel
                            </button>
                          </td>
                        </tr>
                      )}
                    </>
                  )}
                </tbody>
              </table>
            </Form>
          )}
      </Formik>
      </div>
    </div>;
};
export { AuthEmail };